import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  gap: {
    xs: '2.4rem',
    lg: '4rem',
  },
}

export const iconContentSx: SxProps<Theme> = {
  alignItems: 'center',
}

export const iconWrapperSx = ({
  variant,
}: {
  variant: 'white' | 'blue'
}): SxProps<Theme> => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: {
      xs: '6rem',
      lg: '8.8rem',
    },
    minHeight: {
      xs: '6rem',
      lg: '8.8rem',
    },
    maxWidth: {
      xs: '6rem',
      lg: '8.8rem',
    },
    maxHeight: {
      xs: '6rem',
      lg: '8.8rem',
    },
    borderRadius: '50%',
    backgroundColor: (theme) =>
      variant === 'white'
        ? theme.palette.background.paper
        : theme.palette.primary.light,
  }
}

export const iconSx = ({
  variant,
}: {
  variant: 'white' | 'blue'
}): SxProps<Theme> => {
  return {
    width: {
      xs: '3.8rem',
      lg: '5.5rem',
    },
    height: {
      xs: '3.8rem',
      lg: '5.5rem',
    },
    color: (theme) =>
      variant === 'white'
        ? theme.palette.primary.light
        : theme.palette.primary.contrastText,
  }
}

export const textWrapperSx: SxProps<Theme> = {
  gap: {
    xs: '0.8rem',
    lg: '2rem',
  },
  flex: 1,
}

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.contrastText,
}

export const subtitleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.contrastText,
  letterSpacing: '0.04rem',
}
